import { site } from "@/data/site";
import { Reveal } from "@/components/Reveal";

export default function About() {
    return (
        <section id="about" data-testid="about-section" className="bg-[#F4F4F0] text-[#132B21]">
            <div className="mx-auto max-w-[1600px] px-5 py-28 sm:px-10 sm:py-40">
                <Reveal>
                    <p className="mb-4 font-mono text-[11px] uppercase tracking-[0.35em] text-[#E63946]">Über mich</p>
                    <h2 className="mb-16 font-display text-4xl font-bold uppercase leading-none tracking-tight sm:text-6xl lg:text-7xl">
                        Über <span className="text-stroke-dark">BVISION</span>
                    </h2>
                </Reveal>

                <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
                    <Reveal className="lg:col-span-5">
                        <div className="group relative overflow-hidden" data-testid="about-portrait">
                            <img
                                src={site.portrait}
                                alt={`Portrait von ${site.owner}`}
                                loading="lazy"
                                className="aspect-[3/4] w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.04]"
                            />
                            <div
                                className="pointer-events-none absolute inset-0"
                                style={{
                                    background:
                                        "linear-gradient(to top, rgba(19,43,33,0.55), transparent 45%)",
                                }}
                            />
                            <div className="absolute bottom-4 left-4 font-mono text-[10px] uppercase tracking-[0.25em] text-[#F4F4F0]/80">
                                {site.owner} — {site.role}
                            </div>
                        </div>
                    </Reveal>

                    <div className="lg:col-span-7">
                        <Reveal delay={0.1}>
                            <p className="max-w-2xl text-xl font-light leading-relaxed sm:text-2xl">
                                „{site.aboutText}“
                            </p>
                            <p className="mt-6 max-w-xl text-base leading-relaxed text-[#132B21]/70">
                                {site.aboutText2}
                            </p>
                            <p
                                data-testid="about-founded"
                                className="mt-10 font-mono text-[11px] uppercase tracking-[0.3em] text-[#132B21]/60"
                            >
                                BVISION Designer Studio — gegründet <span className="text-[#E63946]">2025</span> in
                                Wuppertal
                            </p>
                        </Reveal>
                        <Reveal delay={0.2}>
                            <p className="mb-5 mt-14 font-mono text-[11px] uppercase tracking-[0.3em] text-[#132B21]/60">
                                Schwerpunkte
                            </p>
                            <ul className="flex flex-wrap gap-3" data-testid="about-focus-list">
                                {site.focus.map((f) => (
                                    <li
                                        key={f}
                                        className="rounded-full border border-[#132B21]/25 px-4 py-2 text-sm text-[#132B21]/90 transition-colors duration-300 hover:border-[#E63946] hover:text-[#E63946]"
                                    >
                                        {f}
                                    </li>
                                ))}
                            </ul>
                        </Reveal>
                    </div>
                </div>
            </div>
        </section>
    );
}
